import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommentsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Comments",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.77 21.12h2.69v5.38c0 .89.72 1.61 1.62 1.61.45 0 .85-.18 1.14-.47l6.53-6.53h8.49c2.08 0 3.76-1.69 3.77-3.77V7.65c0-2.08-1.69-3.76-3.77-3.77H5.77C3.69 3.88 2.01 5.57 2 7.65v9.69c0 2.08 1.69 3.76 3.77 3.77Zm8.08-8.62c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15m-7.54 0c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15m15.08 0c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M5 28c-.14 0-.29-.03-.42-.09-.35-.16-.58-.52-.58-.91V6c0-1.65 1.35-3 3-3h18c1.65 0 3 1.35 3 3v14c0 1.65-1.35 3-3 3H11.36l-5.72 4.77c-.18.15-.41.23-.64.23M7 5c-.55 0-1 .45-1 1v18.87l4.36-3.63c.18-.15.41-.23.64-.23h14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21 11H11c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1M16 15h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};